import { createModelSchemaWrapper } from 'framework/serializr-integration';
import { primitive } from 'serializr';
import { makeAutoObservable } from 'mobx';

export class AssetHealthQualifier {
	accountName: string;
	assetMaintenance: boolean;
	classname: string;
	elementId: string;
	elementName: string;
	id: string;
	name: string;
	serviceId: string;
	serviceName: string;
	shared: boolean;
	state: boolean;
	warning: boolean;

	constructor() {
		makeAutoObservable(this);
	}
}

createModelSchemaWrapper(AssetHealthQualifier, {
	accountName: primitive(),
	assetMaintenance: primitive(),
	classname: primitive(),
	elementId: primitive(),
	elementName: primitive(),
	id: primitive(),
	name: primitive(),
	serviceId: primitive(),
	serviceName: primitive(),
	shared: primitive(),
	state: primitive(),
	warning: primitive(),
});
